import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Icon } from '../Icon';
import { CalendarContainer } from './styles';

function getDayNameAbbr(locale, day) {
  var date = new Date(day);
  return date.toLocaleDateString(locale, {
    weekday: 'short'
  });
}

function getNavigationLabel(locale, day) {
  var date = new Date(day);
  var year = date.getFullYear();
  var month = date.toLocaleDateString(locale, {
    month: 'long'
  });
  return "".concat(month, " ").concat(year);
}

export var Calendar = function Calendar(_ref) {
  var _ref$allowRange = _ref.allowRange,
      allowRange = _ref$allowRange === void 0 ? false : _ref$allowRange,
      _ref$allowPartialRang = _ref.allowPartialRange,
      allowPartialRange = _ref$allowPartialRang === void 0 ? false : _ref$allowPartialRang,
      handleChangeDate = _ref.handleChangeDate,
      selectedDate = _ref.selectedDate;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeStartDate = _useState2[0],
      setActiveStartDate = _useState2[1];

  return React.createElement(CalendarContainer, {
    activeStartDate: activeStartDate,
    onActiveStartDateChange: function onActiveStartDateChange(_ref2) {
      var value = _ref2.value,
          action = _ref2.action;

      if (['onChange', 'next'].includes(action)) {
        setActiveStartDate(value ? value[1] : null);
      }

      if (action === 'prev') {
        setActiveStartDate(value ? value[0] : null);
      }
    },
    minDetail: "month",
    value: selectedDate,
    allowPartialRange: allowPartialRange,
    onChange: function onChange(date) {
      return handleChangeDate(date);
    },
    maxDetail: "month",
    defaultView: "month",
    next2Label: null,
    locale: "pt-BR",
    prev2Label: null,
    selectRange: allowRange,
    showNeighboringMonth: false,
    nextLabel: React.createElement(Icon, {
      name: 'ArrowRight',
      width: 24,
      height: 24,
      fill: '#4b4b4b'
    }),
    prevLabel: React.createElement(Icon, {
      name: 'ArrowLeft',
      width: 24,
      height: 24,
      fill: '#4b4b4b'
    }),
    formatShortWeekday: function formatShortWeekday(locale, date) {
      return getDayNameAbbr(locale, date);
    },
    navigationLabel: function navigationLabel(_ref3) {
      var locale = _ref3.locale,
          date = _ref3.date;
      return getNavigationLabel(locale, date);
    }
  });
};